import React, { useEffect, useState } from 'react';
//import useStyles from './styles'
import { Grid, Typography, Box, Button, ButtonBase, Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import { ROOM_DEMO, ROOM_VDPC, ROOM_URGENT_CARE } from '../../env';
import { mainImage, mainImageOuter } from '../../assets';
import SubMainComponent from '../../components/subMainComponent';
import { AiOutlineLeft } from "react-icons/ai";
import { BiPlusCircle } from 'react-icons/bi';
import { GoCheck } from 'react-icons/go';
import AddChildren from './addChild';
import AddAdult from './addAdult';
import ButtonComponent from '../../components/loaderNew';

const useStyles = makeStyles(theme => ({
    container: {
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        left: 0,
    },
    selectedPatient: {
        fontSize: 20,
        fontWeight: 600,
        padding: '3%',
        width: "100%",
        fontStyle: 'normal',
        color: "#024C9C",
        backgroundColor: "#007AFF1A",
        textAlign: "left",
        borderRadius: 5,
        marginTop: '6%',
        fontFamily: 'Manrope',
    },
    selectedPatientChild: {
        fontSize: 20,
        fontWeight: 600,
        fontFamily: 'Manrope',
        width: "100%",
        color: "#024C9C",
        textAlign: "left",
        borderRadius: 5,
        display: "flex",
        alignItems: "center",
        marginTop: '5%',
    },
    PatientNextButton: {
        display: "flex",
        flexDirection: "column",
        marginTop: '45%',
        justifyContent: "center",
    },
    createAccountButton: {
        height: '74px',
        width: "534px",
        borderRadius: 10,
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 200,
        fontSize: 24,
        color: "#FFFFFF",
        textTransform: "none",
        backgroundColor: '#024C9C',
    },
    iconchild: {
        color: "#024C9C",
        fontSize: 18,
        marginRight: 5,
    },
    iconright: {
        float: "right",
        color: "#024C9C",
    },
}));

const Patients = () => {
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const loading = useSelector(state => state.patientReducer.loading);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const uuid = userData.user.person.uuid;
    const access_token = providerData && providerData.access_token;
    const { user } = userData && userData;
    const { person } = user && user;
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const [openAddChildForm, setAddChildForm] = useState(false);
    const [openAddAdultForm, setAddAdultForm] = useState(false);
    const consentSigned = useSelector(state => state.patientReducer.consentsSigned);
    const childrenList = useSelector(
        state => state.patientReducer.childrenList,
    );
    const addChildResponse = useSelector(state => state.patientReducer.addChildren);
    const addFamilyResponse = useSelector(state => state.patientReducer.addFamily);
    const [childList, setChildList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const { name, identifier, address } = patientDetails || {};


    useEffect(() => {
        if (addFamilyResponse) {
            onCloseModalAdult();
            dispatch(patientActions.onAddFamilyMemberResponse(false));
        }
    }, [addFamilyResponse]);

    useEffect(() => {
        if (userData && userData.token && fhir_patient_id) {
            localStorage.removeItem('registertoken');
            dispatch(patientActions.getPatient(
                fhir_patient_id,
                userData.token
            ));
        }
    }, [userData]);
    useEffect(() => {
        //let patientType = false;
        // let roomName;
        // const { hintos_patient_id, hintos_member_status } = person && person;
        // const type = identifier && identifier?.filter((s) => s?.system === 'urn:oid:fhir-portal')?.map(({ value }) => value).map((item) => {
        //     if (item === 'CCM' || item === 'RPM' || item === 'TCM') {
        //         patientType = true;
        //     }
        // });
        // if (patientType) {
        //     roomName = ROOM_DEMO;
        // } else if (hintos_patient_id !== null && hintos_member_status === 'active') {
        //     roomName = ROOM_VDPC;
        // } else {
        //     roomName = ROOM_VDPC;
        // }
        if (userData && uuid) {
            dispatch(patientActions.onClearDataSuccess({}));
            //dispatch(patientActions.resetPlanAmount());
            setTimeout(() => {
                dispatch(
                    patientActions.validClient(
                        { id: uuid, alias: ROOM_URGENT_CARE, auto: '1' },
                        userData.token,
                    ),
                );
            }, 10);
        }
    }, [userData]);
    useEffect(() => {
        if (access_token && providerData) {
            const params = new FormData();
            params.append('patientId', providerData.id);
            dispatch(
                patientActions.getChildren(params, access_token),
            );
            dispatch(patientActions.onAddChildrenFailed([]));
            onCloseModal();
        }
    }, [access_token, addChildResponse]);
    useEffect(() => {
        if (fhir_patient_id) {
            dispatch(patientActions.checkUserConsentsDetails(fhir_patient_id, userData.token))
        }
    }, [userData]);
    useEffect(() => {
        if (childrenList && name && name.length > 0) {
            setChildList([
                {
                    first_name:
                        (name && name[0] && name[0]?.given && name[0]?.given[0]) || '',
                    last_name: (name && name[0]?.family) || '',
                },
                ...childrenList,
            ]);
        }
    }, [childrenList, name]);
    useEffect(() => {
        if (selectedIndex > 0 && childList.length > 0) {
            const childData = childList[selectedIndex];
            dispatch(patientActions.onAddSelectedChild(childData));
        } else {
            dispatch(patientActions.onRemoveSelectedChild());
        }
    }, [selectedIndex]);

    const onCloseModal = () => {
        setAddChildForm(false);
    }
    const onCloseModalAdult = () => {
        setAddAdultForm(false);
    }
    const onHandleNext = (e) => {
        e.preventDefault();
        if (patientDetails && address && address[0]) {
            const { city, country, line, postalCode, state, } = address && address[0];
            if (address && address[0] && (state === 'AZ' || state === 'Arizona') && !consentSigned) {
                navigate('/room/user')
            } else {
                navigate('/room/medicalHistory');
            }
        } else {
            // popup(`You don't have added your address details yet.\n To Proceed further, Please add your address details by updating your profile.`)
        }
    }
    const onBack = (e) => {
        //e.preventDefault();
        navigate('/');
        //dispatch(registerActions.validateUserResponse({}));
    }

    return (
        <div style={{ padding: '10%' }}>
            <Box>
                <div style={{
                     width: "100%",
                     backgroundColor: "white",
                     //height: "100%",
                     display: "flex",
                     flexDirection: "column",
                     //marginTop: '5%',
                     marginBottom: '2%'
                }}>
                    <Typography  className='topTitle'>Select Patient
                    <a href="" className="backArrow" onClick={onBack}>
                            Logout</a>
                    </Typography>
                    {/* <Button className='titleText' style={{
                        fontFamily: 'Manrope',
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: 24,
                        display: "flex",
                        alignItems: "center",
                        color: "#024C9C",
                        textDecoration: "none",
                    }} onClick={onBack}>
                        <AiOutlineLeft />Back</Button> */}
                </div>
                <Grid item xs={12} md={12} lg={12}>
                    {childList && childList.length > 0 && childList.map((item, index) => {
                        return (
                            <div className={classes.selectedPatient} onClick={() => { setSelectedIndex(index) }}>
                                {item.first_name} {item.last_name}{selectedIndex === index && <GoCheck style={{ alignSelf: 'center' }} size={'5%'} className={classes.iconright} />}
                            </div>);
                    })
                    }
                    {/* {childList.map(({ item, index }) => {
                        <div className={classes.selectedPatient} id={index}>
                            {item.first_name} {item.last_name} <GoCheck className={classes.iconright} />
                        </div>
                    })} */}
                    <div className={classes.selectedPatientChild} style={{ cursor: "pointer" }} onClick={() => setAddChildForm(!openAddChildForm)}>
                        <BiPlusCircle className={classes.iconchild} />
                        <span>Add a child ( Under 18 years )</span>
                    </div>
                    <div className={classes.selectedPatientChild} style={{ cursor: "pointer" }} onClick={() => setAddAdultForm(!openAddAdultForm)}>
                        <BiPlusCircle className={classes.iconchild} /><span> Add an Adult  ( Above 18 years ) </span>
                    </div>
                </Grid>
                <Grid>
                    <div className={classes.PatientNextButton}>
                        <ButtonComponent onClick={(e) => { onHandleNext(e) }} loading={loading} title='Next' />
                        {/* <Button
                            size="large"
                            variant="contained"
                            color='primary'
                            fullWidth
                            style={{ width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', alignSelf: 'center' }}
                            disabled={loading}
                            onClick={(e) => { onHandleNext(e) }}
                        >
                            Next
                        </Button> */}
                    </div>
                </Grid>
            </Box>
            {/* Start Add a Child Popup Model from here  Dharmraj 09-11-2022 */}
            {/* <Modal open={openAddChildForm}>
                <AddChildren onCloseModal={onCloseModal} />
            </Modal> */}
            {/* End Add a Child Popup Model from here  Dharmraj 09-11-2022 */}

            {/* Start Add a Family Member Popup Model from here  Dharmraj 09-11-2022 */}
            <Modal open={openAddAdultForm}>
                <AddAdult onCloseModal={onCloseModalAdult} />
            </Modal>
            {/* End Add a Family Member Popup Model from here  Dharmraj 09-11-2022 */}

            <Modal open={openAddChildForm}>
                <AddChildren onCloseModal={onCloseModal} />
            </Modal>
        </div>
    )
}

export default Patients;
